import { ActionIcon, Tooltip, useMantineColorScheme } from '@mantine/core';
import { TbSun, TbMoon, TbSunMoon } from 'react-icons/tb';

export default function ThemeSwitcher() {
  const { colorScheme, setColorScheme } = useMantineColorScheme();

  const cycleColorScheme = () => {
    const schemes = ['light', 'dark', 'auto'] as const;
    const currentIndex = schemes.indexOf(
      colorScheme as (typeof schemes)[number],
    );
    const nextIndex = (currentIndex + 1) % schemes.length;
    setColorScheme(schemes[nextIndex]);
  };

  const getIcon = () => {
    switch (colorScheme) {
      case 'light':
        return <TbSun size={18} />;
      case 'dark':
        return <TbMoon size={18} />;
      case 'auto':
        return <TbSunMoon size={18} />;
      default:
        return <TbSunMoon size={18} />;
    }
  };

  const getLabel = () => {
    switch (colorScheme) {
      case 'light':
        return 'Light mode (click to switch to Dark)';
      case 'dark':
        return 'Dark mode (click to switch to System)';
      case 'auto':
        return 'System theme (click to switch to Light)';
      default:
        return 'Theme';
    }
  };

  return (
    <Tooltip label={getLabel()}>
      <ActionIcon variant="subtle" size="lg" onClick={cycleColorScheme}>
        {getIcon()}
      </ActionIcon>
    </Tooltip>
  );
}
